import {createApp} from 'vue'
import FeaturedPostSpotCard from './FeaturedPostSpotCard'

const el = '.kb-component--featured-post-spot-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FeaturedPostSpotCardDOM)=>{
            const spotCardData = FeaturedPostSpotCardDOM.dataset.spotCard 
            ? JSON.parse(FeaturedPostSpotCardDOM.dataset.spotCard) 
            : null
            const component = createApp(FeaturedPostSpotCard, {spotCardData}).use(Store)
            component.mount(FeaturedPostSpotCardDOM)
        })
    }
}

